// Web-safe mock for react-native-keychain
// Provides basic keychain functionality for web compatibility

export const getSupportedBiometryType = () => {
  // Web doesn't support biometry, return null
  return Promise.resolve(null);
};

export const setGenericPassword = (username, password, options) => {
  // Mock successful storage
  return Promise.resolve(true);
};

export const getGenericPassword = options => {
  // Mock no stored credentials on web
  return Promise.resolve(false);
};

export const resetGenericPassword = () => {
  // Mock successful reset
  return Promise.resolve(true);
};

export const ACCESS_CONTROL = {
  BIOMETRY_ANY: 'BIOMETRY_ANY',
  BIOMETRY_CURRENT_SET: 'BIOMETRY_CURRENT_SET',
  DEVICE_PASSCODE: 'DEVICE_PASSCODE',
  APPLICATION_PASSWORD: 'APPLICATION_PASSWORD',
  USER_PRESENCE: 'USER_PRESENCE',
};

export const ACCESSIBLE = {
  WHEN_PASSCODE_SET_THIS_DEVICE_ONLY: 'WHEN_PASSCODE_SET_THIS_DEVICE_ONLY',
  WHEN_UNLOCKED: 'WHEN_UNLOCKED',
  WHEN_UNLOCKED_THIS_DEVICE_ONLY: 'WHEN_UNLOCKED_THIS_DEVICE_ONLY',
  AFTER_FIRST_UNLOCK: 'AFTER_FIRST_UNLOCK',
  AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY: 'AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY',
  ALWAYS: 'ALWAYS',
  ALWAYS_THIS_DEVICE_ONLY: 'ALWAYS_THIS_DEVICE_ONLY',
};

export const STORAGE_TYPE = {
  FB: 'FB',
  AES: 'AES',
  RSA: 'RSA',
  KC: 'KC',
};

export const SECURITY_LEVEL = {
  SECURE_SOFTWARE: 'SECURE_SOFTWARE',
  SECURE_HARDWARE: 'SECURE_HARDWARE',
  ANY: 'ANY',
};

export const BIOMETRY_TYPE = {
  TOUCH_ID: 'TouchID',
  FACE_ID: 'FaceID',
  FINGERPRINT: 'Fingerprint',
  FACE: 'Face',
  IRIS: 'Iris',
};
